/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

export const CREATE_CIRCULAR_REQUEST = "CREATE_CIRCULAR_REQUEST";
export const CREATE_CIRCULAR_SUCCESS = "CREATE_CIRCULAR_SUCCESS";
export const CREATE_CIRCULAR_FAILURE = "CREATE_CIRCULAR_FAILURE";

export const UPDATE_CIRCULAR_REQUEST = "UPDATE_CIRCULAR_REQUEST";
export const UPDATE_CIRCULAR_SUCCESS = "UPDATE_CIRCULAR_SUCCESS";
export const UPDATE_CIRCULAR_FAILURE = "UPDATE_CIRCULAR_FAILURE";

export const DELETE_CIRCULAR_REQUEST = "DELETE_CIRCULAR_REQUEST";
export const DELETE_CIRCULAR_SUCCESS = "DELETE_CIRCULAR_SUCCESS";
export const DELETE_CIRCULAR_FAILURE = "DELETE_CIRCULAR_FAILURE";

export const GET_CIRCULARS_REQUEST = "GET_CIRCULARS_REQUEST";
export const GET_CIRCULARS_SUCCESS = "GET_CIRCULARS_SUCCESS";
export const GET_CIRCULARS_FAILURE = "GET_CIRCULARS_FAILURE";
